export default __webpack_public_path__ + "static/media/upload-csv-error.ec52a121.svg";